import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.css']
})
export class SideNavComponent implements OnInit {

  constructor(private router: Router,) { }
  arrowExpand = false;
  currentsubMenu = 0;
  ngOnInit(): void {
  }
  toggleArrow (){
    this.arrowExpand =!this.arrowExpand;
  }
  NavClick(path:string,subMenu=0) {
    this.currentsubMenu = subMenu;
    this.router.navigate([path]);
  }

}
